import { accountSetLoginProject } from '@/api/projectTree.js'
//登录的项目配置
export const setLoginProject = (accountDTO) => {
    accountSetLoginProject(accountDTO).then(res => {
        if (res.code === 1000) {
            Toast.success(res.message)
        }else {
            Toast.error(res.message)
        }
    })
}